<div class="container-sm route-container">

  <h1 class="page-title">
    Elegí el recorrido que querés hacer
  </h1>

  <div class="route-tabs">
    <button
      [class.active]="direction === 'Entrada'"
      (click)="setDirection('Entrada')">
      Entrada
    </button>

    <button
      [class.active]="direction === 'Salida'"
      (click)="setDirection('Salida')">
      Salida
    </button>

    <button
      [class.active]="direction === ''"
      (click)="setDirection('')">
      Todos
    </button>
  </div>

  <div class="route-search">
    <input
      type="text"
      class="form-control"
      placeholder="Buscar recorrido u horario (ej: Laferrere o 15:20)"
      [(ngModel)]="searchTerm"
    />
  </div>

  <div class="route-list">

<div
  class="route-card"
  *ngFor="let route of filteredRoutes()"
  [class.active]="selected?.id === route.id"
  [class.disabled]="!route.has_services"
  (click)="route.has_services && chooseRoute(route)"
>

<div class="route-info">

  <div class="route-name">

    <span
      class="route-badge-new"
      *ngIf="isNewRoute(route)">
      Nuevo
    </span>

    {{ getBaseName(route.name) }}

  </div>

  <div class="route-type">

    {{ getDirectionLabel(route) }}

    <span
      class="route-days-inline"
      *ngIf="route.service_days?.length">

      • {{ getServiceDays(route) }}

    </span>

  </div>

</div>

<div class="route-meta" *ngIf="getTimes(route.name).length">

  <span
    class="route-time"
    *ngFor="let time of getTimes(route.name)">
    {{ time }}
  </span>

</div>

    </div>

  </div>

</div>